export default __webpack_public_path__ + "static/media/mail-background.ec5d4412.png";